module.exports = __webpack_public_path__ + "img/mark0.20198f89.png";